import React from 'react';
import DeudorImageOne from './DeudorImageOne';
import DeudorImageTwo from './DeudorImageTwo';
import DeudorImageThree from './DeudorImageThree';
import DeudorImageFour from './DeudorImageFour';

import './style.css';

const Afiliate = () => {

  return (
    <div className="max-w-7xl mx-auto md:flex md:justify-between md:items-center h-full">
      <div className="mb-8 md:mb-0 md:w-1/3">
        <h2 className="text-gray-700 text-3xl text-center mb-4 md:text-left md:text-4xl">Afíliate a <span className="text-green-300">Fondimex</span></h2>
        <ul className="text-gray-700 leading-loose text-lg">
          <li className="flex items-center mb-4">
            <span  className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">1</span><span>Llena el formulario de aplicación</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">2</span><span>Envía la documentación requerida</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">3</span><span>Espera la aprobación de tu línea de crédito</span>
          </li>
          <li className="flex items-center mb-4">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">4</span><span>Invita a tus proveedores</span>
          </li>
          <li className="flex items-center">
            <span className="w-8 h-8 mr-4 opacity-80 flex items-center justify-center text-red-100 rounded-full bg-red-300">5</span><span>Disfruta de los beneficios de Fondimex</span>
          </li>
        </ul>
      </div>
      <div className="w-1/2 grid">
        <DeudorImageOne />
        <DeudorImageTwo />
        <DeudorImageThree />
        <DeudorImageFour />
      </div>
    </div>
  );
}

export default Afiliate;